








































































import { mapActions } from 'vuex';
import { computed, getCurrentInstance, PropType } from 'vue';
import TableRow from '../../../shared/libs/table/components/TableRow.vue';
import TableCell from '../../../shared/libs/table/components/TableCell.vue';
import Icon from '../../../shared/components/Icon.vue';
import AulaButton from '../../../shared/components/AulaButton.vue';
import { SecureDocumentModel } from '../../../shared/models/secureDocument.model';
import { format } from '../../../shared/utils/dateUtil.js';
import { dateFormatEnum } from '../../../shared/enums/dateFormatEnum';
import { documentTypes } from '../../../shared/enums/documentTypes';
import truncate from 'lodash/truncate';
import { InstitutionProfileModel } from '../../../shared/models/institutionProfile.model';
import IconContainer from '../../../shared/components/IconContainer.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import Button from '../../../shared/directives/button.js';
import { types } from '../../store/types/types.js';
import AttachmentList from '../../../shared/components/AttachmentList.vue';
import { useEsdhExport } from '../../composables/documents/useEsdhExport';
import DocumentEsdhExportChild from './DocumentEsdhExportChild.vue';

const MAX_SECURE_NOTE_DESCRIPTION_LENGTH = 300;
export default {
  components: { DocumentEsdhExportChild, AttachmentList, IconContainer, Icon, AulaButton, TableRow, TableCell },
  directives: {
    Button,
  },
  props: {
    document: {
      type: Object as PropType<SecureDocumentModel>,
      required: true,
    },
    isChildSelectable: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove'],
  setup(props) {
    const { proxy } = getCurrentInstance();
    const { removeDocument, toggleChild, getSelectedChildIds } = useEsdhExport();
    const selectedChildIds = computed(() => {
      if (props.isChildSelectable) {
        return getSelectedChildIds(props.document.id);
      }
      return props.document.associatedInstitutionProfiles.map(profile => profile.id);
    });
    const firstChild = computed(() =>
      props.document.associatedInstitutionProfiles.find(child => selectedChildIds.value[0] === child.id)
    );
    const collapsedChildList = computed(() =>
      proxy.$tc('label.children_summary', selectedChildIds.value.length - 1, {
        name: firstChild.value.name,
        metadata: firstChild.value.metadata,
        count: selectedChildIds.value.length - 1,
      })
    );

    return {
      selectedChildIds,
      collapsedChildList,
      removeDocument,
      toggleChild,
    };
  },
  data() {
    return {
      expanded: this.isExpanded,
      attachments: [],
      isLoading: false,
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    isShownCheckBox() {
      return this.isChildSelectable && this.regardingChildren.length > 0;
    },
    showSummaryChildren() {
      return this.document.associatedInstitutionProfiles.length > 1 && !this.expanded;
    },
    regardingChildren() {
      const children = this.document.associatedInstitutionProfiles;
      return this.getSortedChildrenByName(children);
    },
    regardingChildrenNameList() {
      return this.document.associatedInstitutionProfiles
        .map((child: InstitutionProfileModel) => this.getChildNameWithMetadata(child))
        .join(', ');
    },
    editedAt() {
      if (!this.document.updatedAt) {
        return '';
      }
      return format(this.document.updatedAt, dateFormatEnum.LONG_DATE_TIME);
    },
    description() {
      switch (this.document.documentType) {
        case documentTypes.NOTE:
          return truncate(this.document.description ?? '', { length: MAX_SECURE_NOTE_DESCRIPTION_LENGTH });
        case documentTypes.RICHDOCUMENT:
          return this.document.templateTitle ?? '';
        default:
          return '';
      }
    },
    hasExtraMetadata() {
      return this.document.associatedInstitutionProfiles.length > 1 || this.hasMedia;
    },
    hasMedia() {
      return this.document.hasMedia;
    },
  },
  watch: {
    isExpanded(newVal) {
      this.expanded = newVal;
      this.fetchExtraMetadata();
    },
  },
  methods: {
    ...mapActions({
      loadInternalDocument: types.ACTION_LOAD_INTERNAL_DOCUMENT,
      loadExternalDocument: types.ACTION_LOAD_EXTERNAL_DOCUMENT,
    }),
    getSortedChildrenByName(children: InstitutionProfileModel[]) {
      return children.sort((child1: InstitutionProfileModel, child2: InstitutionProfileModel) =>
        child1.name.localeCompare(child2.name)
      );
    },
    onRemove() {
      this.$emit('remove', this.document.id);
    },
    handleChildError() {
      this.expanded = true;
    },
    async toggleExtraMetadata() {
      this.expanded = !this.expanded;
      await this.fetchExtraMetadata();
    },
    async fetchExtraMetadata() {
      const isAttachmentLoaded = this.attachments.length > 0;
      if (this.expanded && this.document.hasMedia && !isAttachmentLoaded) {
        await this.loadAttachments();
      }
    },
    getChildNameWithMetadata(child: InstitutionProfileModel) {
      return `${child.name} (${child.metadata})`;
    },
    async loadAttachments() {
      this.isLoading = true;

      const payload = { id: this.document.id };
      const documentType = this.document.documentType;
      let document = null;

      if (documentType === documentTypes.EXTERNAL) {
        document = await this.loadExternalDocument(payload);
      } else {
        document = await this.loadInternalDocument(payload);
      }

      this.attachments = document.attachments;
      this.isLoading = false;
    },
  },
};
